import { timeStamp } from "console";
import { Message, ChatSummary } from "../types/chat";
import { formatDate } from "./helpers";

type ApiMsg = {
  id: number;
  role: "user" | "bot";
  content: string;                 // строка; у bot – JSON
  output: any | null;              // приходит, но мы им не пользуемся
  created_at: string;
};
export type ChatFromApi = {
  id: number;
  external_id: string;          // ← это UUID
  title: string | null;
  created_at: string;
  messages?: ApiMsg[];
};


export function mapApiChat(chat: ChatFromApi): {
  summary: ChatSummary;
  messages: Message[];
} {
  const mappedMessages: Message[] = (chat.messages ?? []).map((m) => {
    if (m.role === "user") {
      return {
        id: String(m.id),
        type: "user",
        text: m.content,
        timestamp: m.created_at,
      };
    }

    // bot‑сообщение
    const parsed = m.output ?? (() => {
      try {
        return JSON.parse(m.content ?? "{}");
      } catch {
        return {};
      }
    })();

    const tableData =
      parsed.result_preview && parsed.result_preview.length
        ? {
            headers: Object.keys(parsed.result_preview[0]),
            rows: parsed.result_preview,
          }
        : undefined;
        const messageTimestamp = m.created_at; // ❗ не форматируй тут
        return {
      id: String(m.id),
      type: "bot",
      text: tableData ? undefined : parsed.sql ?? parsed.text,
      tableData,
      explanation: parsed.explanation,
      timestamp: messageTimestamp,
      isTableExpanded: false,
    };
  });

  return {
    summary: {
      id: chat.id,                        // ← числовой ID для useChatMessages
      chatId: chat.external_id,          // ← UUID, которым оперирует фронт
      title: chat.title ?? "Untitled Chat",
      dbId: "self",                      // пока что, если не приходит с API
      dbName: "Self",
    },
    messages: mappedMessages,
  };  
}
